<template>
  <v-menu
    v-model="showMenu"
    transition="slide-y-transition"
    top
    offset-x
    :close-on-content-click="false"
    v-if="documents.length"
  >
    <template v-slot:activator="{ on: menu, attrs }">
      <v-tooltip bottom :disabled="showMenu">
        <template v-slot:activator="{ on: tooltip }">
          <a-btn
            v-bind="attrs"
            v-on="{ ...menu, ...tooltip }"
            small
            color="primaryDark"
            dark
          >
            {{ $t("agenda.lblInsertDocLink") }}
            <v-icon v-if="showMenu" right>mdi-chevron-up</v-icon>
            <v-icon v-else right>mdi-chevron-down</v-icon>
          </a-btn>
        </template>
        <span v-html="$t('agenda.lblInsertDocLink')"></span>
      </v-tooltip>
    </template>
    <v-banner color="primaryLight1" class="pl-0" sticky single-line tile>
      <v-toolbar color="primaryLight1" class="pl-0">
        <span> {{ $t("agenda.lblInsertDocLink") }}</span>
        <v-spacer></v-spacer>
        <CloseIcon @click="showMenu = false" />
      </v-toolbar>
    </v-banner>
    <v-card class="menu-card">
      <v-card-text class="scrollable-list pa-0">
        <v-list dense class="pa-0">
          <v-list-group
            v-for="(category, index) in documents"
            :key="index"
            :value="true"
            no-action
            dense
          >
            <template v-slot:activator>
              <v-list-item-title
                ><span class="text-subtitle-1 black--text">{{
                  category.title
                }}</span></v-list-item-title
              >
            </template>
            <template
              v-if="
                Array.isArray(category.documents) &&
                category.documents.some((sub) => Array.isArray(sub.documents))
              "
            >
              <v-list-group
                v-for="(subCategory, subIndex) in category.documents"
                :key="subIndex"
                :value="true"
                no-action
                sub-group
              >
                <template v-slot:activator>
                  <v-list-item-content>
                    <v-list-item-title>
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <span v-bind="attrs" v-on="on">
                            {{ subCategory.title }}
                          </span>
                        </template>
                        <span> {{ subCategory.title }}</span>
                      </v-tooltip>
                    </v-list-item-title>
                  </v-list-item-content>
                </template>
                <v-list-item
                  v-for="(doc, docIndex) in subCategory.documents || []"
                  :key="`topic-document-${docIndex}`"
                  dense
                  style="min-height: 30px; height: 30px"
                >
                  <v-list-item-content>
                    <v-list-item-title class="fixed-width">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <span v-bind="attrs" v-on="on">
                            {{ doc.fileName }}
                          </span>
                        </template>
                        <span> {{ doc.fileName }}</span>
                      </v-tooltip>
                    </v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          icon
                          small
                          v-bind="attrs"
                          v-on="on"
                          @click.stop="copyToClipboard(doc)"
                          class="ml-4"
                        >
                          <v-icon small>mdi-content-copy</v-icon>
                        </v-btn>
                      </template>
                      <span>{{ $t("lblCopyClipBoard") }}</span>
                    </v-tooltip>
                  </v-list-item-action>
                </v-list-item>
              </v-list-group>
            </template>
            <template v-else>
              <v-list-item
                v-for="(doc, docIndex) in category.documents"
                :key="`topic-document-${docIndex}`"
                dense
                style="min-height: 30px; height: 30px"
              >
                <v-list-item-content>
                  <v-list-item-title class="fixed-width">
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <span v-bind="attrs" v-on="on">
                          {{ doc.fileName }}
                        </span>
                      </template>
                      <span> {{ doc.fileName }}</span>
                    </v-tooltip>
                  </v-list-item-title>
                </v-list-item-content>
                <v-list-item-action>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        small
                        v-bind="attrs"
                        v-on="on"
                        @click.stop="copyToClipboard(doc)"
                        class="ml-4"
                      >
                        <v-icon small>mdi-content-copy</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ $t("lblCopyClipBoard") }}</span>
                  </v-tooltip>
                </v-list-item-action>
              </v-list-item>
            </template>
          </v-list-group>
        </v-list>
      </v-card-text>
    </v-card>
  </v-menu>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "MenuMeetingTopicDocuments",
  data() {
    return {
      showMenu: false,
    };
  },
  props: {
    type: {
      type: String,
      default: "meeting",
    },
  },
  computed: {
    ...mapState({
      meetingDetails: (state) => state.meeting.meetingDetails,
    }),
    selectedTenant() {
      return sessionStorage.getItem("tenantId");
    },
    documents() {
      const docItems = [];
      if (!this.meetingDetails) {
        return [];
      }
      if (this.meetingDetails.topics && this.meetingDetails.topics.length) {
        const topicDocuments = this.meetingDetails.topics
          .map((topic) => ({
            title: topic.topicName,
            documents: topic.documents.map((doc) => ({
              documentId: doc.documentId,
              fileName: doc.fileName,
              mimetype: doc.mimetype,
              document_link: `${window.location.origin}/download/${doc.documentId}/tenant/${this.selectedTenant}`,
            })),
          }))
          .filter((topic) => topic.documents.length > 0);
        if (topicDocuments.length > 0) {
          docItems.push({
            title: this.$t("agenda.lblTopicDocument"),
            documents: topicDocuments,
          });
        }
      }

      if (
        this.meetingDetails.momDocuments &&
        this.meetingDetails.momDocuments.length
      ) {
        const momDocuments = this.meetingDetails.momDocuments.map((doc) => ({
          documentId: doc.documentId,
          fileName: doc.fileName,
          mimetype: doc.mimetype,
          document_link: `${window.location.origin}/download/${doc.documentId}/tenant/${this.selectedTenant}`,
        }));
        if (momDocuments.length > 0) {
          docItems.push({
            title: this.$t("agenda.lblMOMDocument"),
            documents: momDocuments,
          });
        }
      }

      if (
        this.meetingDetails.generalMeetingDocs &&
        this.meetingDetails.generalMeetingDocs.length
      ) {
        const genDocuments = this.meetingDetails.generalMeetingDocs.map(
          (doc) => ({
            documentId: doc.documentId,
            fileName: doc.fileName,
            mimetype: doc.mimetype,
            document_link: `${window.location.origin}/download/${doc.documentId}/tenant/${this.selectedTenant}`,
          })
        );
        if (genDocuments.length > 0) {
          docItems.push({
            title: this.$t("documents.lblGenMeetingDoc"),
            documents: genDocuments,
          });
        }
      }
      return docItems;
    },
  },
  methods: {
    copyToClipboard,
  },
};

function copyToClipboard(doc) {
  const text = doc.document_link;
  const fileName = doc.fileName;
  const fileUrl = `${text}/${fileName}`;
  navigator.clipboard.writeText(encodeURI(fileUrl));
  this.showMenu = false;
}
</script>

<style scoped>
::v-deep .v-banner__wrapper {
  padding: 0px !important;
}
/* Fix menu height and enable scrolling */
.menu-card {
  width: 450px;
  min-width: 450px; /* Adjust as needed */
  max-height: 200px; /* Prevents menu from hiding */
  overflow-y: auto;
}

/* Scrollable list */
.scrollable-list {
  max-height: 200px; /* Enables scrolling if needed */
  overflow-y: auto;
}

/* Fixed document name width */
.fixed-width {
  max-width: 250px; /* Prevents text overflow */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
